export default {
    computed: {
        appleClientId() {
            return globalThis?.ENV?.VUE_APP_APPLE_CLIENT_ID || '';
        }
    }
};
